import React, { useState } from 'react';
import axios from 'axios';
import API_BASE_URL from"../Config/config";

const AddQuestionForm = ({ onAdd, track }) => {
 const [showForm, setShowForm] = useState(false);
 const [form, setForm] = useState({
 level: 1,
 question: '',
 option_a: '',
 option_b: '',
 option_c: '',
 option_d: '',
 correct_option: 'A',
 });

 const handleChange = (e) => {
 setForm({ ...form, [e.target.name]: e.target.value });
 };

 const handleSubmit = async (e) => {
 e.preventDefault();
 try {
 const res = await axios.post(`${API_BASE_URL}/sgl-tables/${track}`, form);
 onAdd(res.data);
 setForm({
 level: 1,
 question: '',
 option_a: '',
 option_b: '',
 option_c: '',
 option_d: '',
 correct_option: 'A',
 });
 setShowForm(false);
 } catch (err) {
 console.error('Failed to add question:', err);
 }
 };

 return (
 <div className="mb-6">
 <button
 onClick={() => setShowForm(!showForm)}
 className="px-4 py-2 bg-secondary text-black font-bold rounded hover:bg-primary"
 >
 {showForm ? 'Close Form' : 'Add Question'}
 </button>

 {showForm && (
 <form
 onSubmit={handleSubmit}
 className="bg-[#111] text-white p-6 rounded-xl shadow-lg mt-4 border border-secondary"
 >
 <h3 className="text-xl font-bold text-primary mb-4">Add New Question</h3>
 <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
 <input type="number" name="level" placeholder="Level" value={form.level} onChange={handleChange} className="p-2 rounded bg-bgMain text-body" required />
 <input type="text" name="question" placeholder="Question" value={form.question} onChange={handleChange} className="p-2 rounded bg-bgMain text-body col-span-2" required />
 <input type="text" name="option_a" placeholder="Option A" value={form.option_a} onChange={handleChange} className="p-2 rounded bg-bgMain text-body" required />
 <input type="text" name="option_b" placeholder="Option B" value={form.option_b} onChange={handleChange} className="p-2 rounded bg-bgMain text-body" required />
 <input type="text" name="option_c" placeholder="Option C" value={form.option_c} onChange={handleChange} className="p-2 rounded bg-bgMain text-body" required />
 <input type="text" name="option_d" placeholder="Option D" value={form.option_d} onChange={handleChange} className="p-2 rounded bg-bgMain text-body" required />
 <select name="correct_option" value={form.correct_option} onChange={handleChange} className="p-2 rounded bg-bgMain text-body col-span-2">
 <option value="A">Correct Option: A</option>
 <option value="B">Correct Option: B</option>
 <option value="C">Correct Option: C</option>
 <option value="D">Correct Option: D</option>
 </select>
 </div>
 <button type="submit" className="mt-4 px-4 py-2 bg-secondary text-black font-bold rounded hover:bg-primary">
 Submit Question
 </button>
 </form>
 )}
 </div>
 );
};

export default AddQuestionForm;



